var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{on:{"click":function($event){$event.preventDefault();return _vm.createOauthApi()}}},[_vm._v("QUick Book")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }